module.exports = __webpack_public_path__ + "media/icons/facebook-black-aa0ffe71.png";